import Vue from 'vue'
import './registerServiceWorker'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import { store } from './store'
import Property from './components/Property.vue'

// Must use process.env.VUE_APP_CLIENT directly so webpack can drop the unused branch
let Root
if (process.env.VUE_APP_CLIENT === 'petruth') {
  // Petruth has no Bootstrap of its own, so the widget ships it
  require('bootstrap/dist/css/bootstrap.css')
  require('bootstrap-vue/dist/bootstrap-vue.css')
  // Petruth mounts the router app so /#/petruth-group works
  Root = require('./App.vue').default
} else {
  // Queenwood's theme already provides Bootstrap
  Root = require('./components/SearchWidget.vue').default
}
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoins, faPhoneAlt, faLock, faUnlock, faSquare, faEye, faEnvelope, faBolt, faAsterisk, faComments, faChevronDown, faChevronUp, faCheckSquare, faBell, faQuestionCircle, faUserCircle, faDownload, faSync, faSitemap, faHome, faSmileWink, faArrowCircleRight, faArrowCircleLeft, faCircle, faDotCircle, faCheckCircle, faTimesCircle, faExclamationCircle, faTachometerAlt, faChartArea, faChartPie, faChartBar, faCalendarCheck, faClipboardList, faUsersCog, faCog, faChevronRight, faExclamationTriangle, faSearch, faSignInAlt, faWalking, faPhone, faCloudDownloadAlt, faMapMarkerAlt, faDesktop, faHotTub, faWifi, faFish, faDog, faWheelchair, faCalendarAlt, faClock, faUsers, faUmbrellaBeach, faSave, faAlignJustify, faTh, faBars, faClipboard, faLink, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueLodash from 'vue-lodash'
import Vuelidate from 'vuelidate'
import VuePikaday from '@netcz/vue-pikaday';
Vue.use(VuePikaday);

import '@netcz/vue-pikaday/dist/vue-pikaday.min.css';

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);


Vue.use(Vuelidate) 
import VCalendar from 'v-calendar';

Vue.use(VCalendar)


Vue.use(BootstrapVue);
library.add(faCoins, faPhoneAlt, faLock, faUnlock, faSquare, faEye, faEnvelope, faBolt, faAsterisk, faComments, faChevronDown, faChevronUp, faCheckSquare, faArrowCircleLeft, faArrowCircleRight, faQuestionCircle, faBell, faUserCircle, faDownload, faSync, faHome, faSmileWink, faCircle, faDotCircle, faCheckCircle, faTimesCircle, faExclamationCircle, faTachometerAlt, faChartArea, faChartPie, faChartBar, faCalendarCheck, faClipboardList, faUsersCog, faCog, faChevronRight, faExclamationTriangle, faSearch, faSignInAlt, faWalking, faPhone, faCloudDownloadAlt, faMapMarkerAlt, faDesktop, faHotTub, faWifi, faFish, faDog, faWheelchair, faCalendarAlt, faSitemap, faClock, faUsers, faUmbrellaBeach, faSave, faAlignJustify, faTh, faBars, faClipboard, faLink, faUser)

Vue.use(require('vue-moment'));

Vue.use(VueLodash)

Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(Root)
}).$mount('#vue-search-widget')

// new Vue({
//   router,
//   store,
//   render: h => h(Property)
// }).$mount('#vue-property')

new Vue({
  el: '#vue-property',
  store,
  router,
  components: { Property },
  render: (h) => {
    return h(Property)
  }
})
